import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import PPDashboardFilter, { FilterState } from './PPDashboardFilter';
import VistedCntsCard from './VistedCntsCard';
import { PpBarChartParams } from '../Pallipaarvai.service';
import PPBarChartCnts from './PPBarChartCnts';
import ObsSchoolListBarChart from './ObsSchoolListBarChart';
import '../pallipaarvai.scss';

const PallipaarvaiDashboard: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const previousMonth = String(new Date().getMonth()); // previous month (0-based getMonth() == current month - 1 in 1-based)
  const [filters, setFilters] = useState<FilterState>({
    academicYear: '37',
    month_id: previousMonth,
    district: null,
    block: null,
    category: null,
    management: null,
    designation: null,
  });

  // Build API params from filter state
  const apiParams: PpBarChartParams = {
    acad_yr: filters.academicYear ?? undefined,
    month_id: filters.month_id ?? undefined,
    district_id: filters.district ?? undefined,
    block_id: filters.block ?? undefined,
    category_id: filters.category ?? undefined,
    management_id: filters.management ?? undefined,
    designation_id: filters.designation ?? undefined,
  };

  // When chart drills into district/block, sync filter dropdowns
  const handleDrillChange = (
    districtId: string | null,
    blockId: string | null
  ) => {
    setFilters((prev) => ({
      ...prev,
      district: districtId,
      block: blockId,
    }));
  };

  return (
    <div className="container-fluid pp-dashboard">
      <div className="card p-4">
        <h4 className="mb-3 text-center">Pallipaarvai Dashboard</h4>

        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header="Overall Observation">
            <div className="p-2 pt-3">
              <PPDashboardFilter filters={filters} onFilter={setFilters} />
              <VistedCntsCard filterParams={apiParams} />
              <PPBarChartCnts filterParams={apiParams} />
              <ObsSchoolListBarChart
                filterParams={apiParams}
                onDrillChange={handleDrillChange}
              />
            </div>
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default PallipaarvaiDashboard;
